export default {
  props: {
    upShow: {
      type: Boolean,
      default: false
    },
    downShow: {
      type: Boolean,
      default: false
    }
  }
};